import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import { PageMetaData } from '@/components/atomic/PageMetaData'
import { Header } from '@/components/styleguide/Header'
import { SearchContentHeader } from '@/components/styleguide/SearchContentHeader'
import { Faqs } from '@/components/views/Faqs'
import { SearchResultsAndFilters } from '@/components/views/SearchResultsAndFilters'
import { constants, FILTER_VEHICLE_TYPES_CARS } from '@/lib/constants'
import { getPageContentItemService } from '@/lib/services/pageService'
import { landedOnCarSearchPage, storePageNumber } from '@/store/reducers/search'
import { clearPaintOptionVehicle, clearSelectedPaintOption } from '@/store/reducers/vehicle'

const CarSearchPage = ({ faqList, pageContent }) => {
  const router = useRouter()
  const dispatch = useDispatch()
  const [status, setStatus] = useState(constants.componentStatus.LOADING)
  const [showPageContent, setShowPageContent] = useState(true)

  useEffect(() => {
    if (router.query.page) {
      dispatch(storePageNumber(Number(router.query.page)))
      return setShowPageContent(false)
    }

    if (router.query.results === 'ai') {
      return setShowPageContent(false)
    }

    setStatus(constants.componentStatus.LOADING)
    return dispatch(landedOnCarSearchPage(router.asPath))
  }, [router.query, dispatch, router.asPath])

  useEffect(() => {
    dispatch(clearSelectedPaintOption())
    dispatch(clearPaintOptionVehicle())
  }, [dispatch])

  return (
    <>
      <PageMetaData
        title="Search Car Lease Deals | Car Lease Comparison Made Easy | LeaseLoco"
        pageTitle="Search Car Lease Deals | Car Lease Comparison Made Easy | LeaseLoco"
        description="Find and compare millions of the hottest lease deals ranked by the most powerful value-based search in the market."
        pageUrl={router.asPath.split('?')[0]}
        canonical={`${process.env.NEXT_PUBLIC_URL}${router.asPath.split('?')[0]}`}
        image={constants.imageHost.social}
      />
      <Header
        backgroundColor="backdrop"
        width="browse"
        hasBorderBottom="desktop"
        hideNav="mobile"
      />
      <SearchResultsAndFilters
        setStatus={setStatus}
        isVans={false}
        status={status}
      />
      {showPageContent && (
        <SearchContentHeader
          isVans={false}
          pageContent={pageContent}
          showBreadcrumbs={false}
          showLinks={false}
          isBottom={true}
        />
      )}
      <section className="container-fluid container--config-faqs">
        <div className="config-page__faqs">
          <Faqs
            vehicleType={FILTER_VEHICLE_TYPES_CARS}
            serverFaqList={faqList}
          />
        </div>
      </section>
    </>
  )
}

export default CarSearchPage

export const getServerSideProps = async () => {
  let pageContent
  let faqList

  try {
    try {
      const response = await getPageContentItemService({
        type: 'FAQ_SEARCH',
        defaultUrlKey: 'car-leasing/search',
        urlKey: 'car-leasing/search',
      })

      faqList = response.content.items.filter(
        faq => Number(faq.vehicleType) === FILTER_VEHICLE_TYPES_CARS,
      )
    } catch (e) {
      faqList = null
    }

    try {
      const contentResponse = await getPageContentItemService({
        type: 'BANNER',
        page: '1',
        urlKey: 'car-leasing/search',
      })

      pageContent = { ...contentResponse.content, urlKey: contentResponse.urlKey }
    } catch (err) {
      pageContent = null
    }

    return {
      props: {
        faqList,
        pageContent,
      },
    }
  } catch (err) {
    return {
      props: {
        faqList: [],
        pageContent: null,
      },
    }
  }
}
